// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IndySoft API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BatchCreateCalibrationPointsCommand } from '../models';
// @ts-ignore
import type { BatchCreateEventDocumentsCommand } from '../models';
// @ts-ignore
import type { CalibrationPointViewModel } from '../models';
// @ts-ignore
import type { EventDocumentViewModel } from '../models';
/**
 * EnterpriseSyncApi - axios parameter creator
 * @export
 */
export const EnterpriseSyncApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} eventNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnterpriseSyncCalibrationPointsEventNumberGet: async (eventNumber: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventNumber' is not null or undefined
            assertParamExists('apiEnterpriseSyncCalibrationPointsEventNumberGet', 'eventNumber', eventNumber)
            const localVarPath = `/api/enterprise-sync/calibration-points/{eventNumber}`
                .replace(`{${"eventNumber"}}`, encodeURIComponent(String(eventNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BatchCreateCalibrationPointsCommand} [batchCreateCalibrationPointsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnterpriseSyncCalibrationPointsPost: async (batchCreateCalibrationPointsCommand?: BatchCreateCalibrationPointsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/enterprise-sync/calibration-points`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchCreateCalibrationPointsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} eventNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnterpriseSyncEventDocumentsEventNumberGet: async (eventNumber: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventNumber' is not null or undefined
            assertParamExists('apiEnterpriseSyncEventDocumentsEventNumberGet', 'eventNumber', eventNumber)
            const localVarPath = `/api/enterprise-sync/event-documents/{eventNumber}`
                .replace(`{${"eventNumber"}}`, encodeURIComponent(String(eventNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BatchCreateEventDocumentsCommand} [batchCreateEventDocumentsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnterpriseSyncEventDocumentsPost: async (batchCreateEventDocumentsCommand?: BatchCreateEventDocumentsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/enterprise-sync/event-documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchCreateEventDocumentsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnterpriseSyncApi - functional programming interface
 * @export
 */
export const EnterpriseSyncApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnterpriseSyncApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} eventNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnterpriseSyncCalibrationPointsEventNumberGet(eventNumber: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalibrationPointViewModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnterpriseSyncCalibrationPointsEventNumberGet(eventNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseSyncApi.apiEnterpriseSyncCalibrationPointsEventNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BatchCreateCalibrationPointsCommand} [batchCreateCalibrationPointsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnterpriseSyncCalibrationPointsPost(batchCreateCalibrationPointsCommand?: BatchCreateCalibrationPointsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalibrationPointViewModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnterpriseSyncCalibrationPointsPost(batchCreateCalibrationPointsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseSyncApi.apiEnterpriseSyncCalibrationPointsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} eventNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnterpriseSyncEventDocumentsEventNumberGet(eventNumber: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventDocumentViewModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnterpriseSyncEventDocumentsEventNumberGet(eventNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseSyncApi.apiEnterpriseSyncEventDocumentsEventNumberGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BatchCreateEventDocumentsCommand} [batchCreateEventDocumentsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnterpriseSyncEventDocumentsPost(batchCreateEventDocumentsCommand?: BatchCreateEventDocumentsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventDocumentViewModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnterpriseSyncEventDocumentsPost(batchCreateEventDocumentsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseSyncApi.apiEnterpriseSyncEventDocumentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EnterpriseSyncApi - factory interface
 * @export
 */
export const EnterpriseSyncApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnterpriseSyncApiFp(configuration)
    return {
        /**
         * 
         * @param {EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsEventNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnterpriseSyncCalibrationPointsEventNumberGet(requestParameters: EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsEventNumberGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalibrationPointViewModel>> {
            return localVarFp.apiEnterpriseSyncCalibrationPointsEventNumberGet(requestParameters.eventNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnterpriseSyncCalibrationPointsPost(requestParameters: EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalibrationPointViewModel>> {
            return localVarFp.apiEnterpriseSyncCalibrationPointsPost(requestParameters.batchCreateCalibrationPointsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnterpriseSyncApiApiEnterpriseSyncEventDocumentsEventNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnterpriseSyncEventDocumentsEventNumberGet(requestParameters: EnterpriseSyncApiApiEnterpriseSyncEventDocumentsEventNumberGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventDocumentViewModel>> {
            return localVarFp.apiEnterpriseSyncEventDocumentsEventNumberGet(requestParameters.eventNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnterpriseSyncApiApiEnterpriseSyncEventDocumentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnterpriseSyncEventDocumentsPost(requestParameters: EnterpriseSyncApiApiEnterpriseSyncEventDocumentsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventDocumentViewModel>> {
            return localVarFp.apiEnterpriseSyncEventDocumentsPost(requestParameters.batchCreateEventDocumentsCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnterpriseSyncApi - interface
 * @export
 * @interface EnterpriseSyncApi
 */
export interface EnterpriseSyncApiInterface {
    /**
     * 
     * @param {EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsEventNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseSyncApiInterface
     */
    apiEnterpriseSyncCalibrationPointsEventNumberGet(requestParameters: EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsEventNumberGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalibrationPointViewModel>>;

    /**
     * 
     * @param {EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseSyncApiInterface
     */
    apiEnterpriseSyncCalibrationPointsPost(requestParameters?: EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalibrationPointViewModel>>;

    /**
     * 
     * @param {EnterpriseSyncApiApiEnterpriseSyncEventDocumentsEventNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseSyncApiInterface
     */
    apiEnterpriseSyncEventDocumentsEventNumberGet(requestParameters: EnterpriseSyncApiApiEnterpriseSyncEventDocumentsEventNumberGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventDocumentViewModel>>;

    /**
     * 
     * @param {EnterpriseSyncApiApiEnterpriseSyncEventDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseSyncApiInterface
     */
    apiEnterpriseSyncEventDocumentsPost(requestParameters?: EnterpriseSyncApiApiEnterpriseSyncEventDocumentsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventDocumentViewModel>>;

}

/**
 * Request parameters for apiEnterpriseSyncCalibrationPointsEventNumberGet operation in EnterpriseSyncApi.
 * @export
 * @interface EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsEventNumberGetRequest
 */
export interface EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsEventNumberGetRequest {
    /**
     * 
     * @type {number}
     * @memberof EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsEventNumberGet
     */
    readonly eventNumber: number
}

/**
 * Request parameters for apiEnterpriseSyncCalibrationPointsPost operation in EnterpriseSyncApi.
 * @export
 * @interface EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsPostRequest
 */
export interface EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsPostRequest {
    /**
     * 
     * @type {BatchCreateCalibrationPointsCommand}
     * @memberof EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsPost
     */
    readonly batchCreateCalibrationPointsCommand?: BatchCreateCalibrationPointsCommand
}

/**
 * Request parameters for apiEnterpriseSyncEventDocumentsEventNumberGet operation in EnterpriseSyncApi.
 * @export
 * @interface EnterpriseSyncApiApiEnterpriseSyncEventDocumentsEventNumberGetRequest
 */
export interface EnterpriseSyncApiApiEnterpriseSyncEventDocumentsEventNumberGetRequest {
    /**
     * 
     * @type {number}
     * @memberof EnterpriseSyncApiApiEnterpriseSyncEventDocumentsEventNumberGet
     */
    readonly eventNumber: number
}

/**
 * Request parameters for apiEnterpriseSyncEventDocumentsPost operation in EnterpriseSyncApi.
 * @export
 * @interface EnterpriseSyncApiApiEnterpriseSyncEventDocumentsPostRequest
 */
export interface EnterpriseSyncApiApiEnterpriseSyncEventDocumentsPostRequest {
    /**
     * 
     * @type {BatchCreateEventDocumentsCommand}
     * @memberof EnterpriseSyncApiApiEnterpriseSyncEventDocumentsPost
     */
    readonly batchCreateEventDocumentsCommand?: BatchCreateEventDocumentsCommand
}

/**
 * EnterpriseSyncApi - object-oriented interface
 * @export
 * @class EnterpriseSyncApi
 * @extends {BaseAPI}
 */
export class EnterpriseSyncApi extends BaseAPI implements EnterpriseSyncApiInterface {
    /**
     * 
     * @param {EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsEventNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseSyncApi
     */
    public apiEnterpriseSyncCalibrationPointsEventNumberGet(requestParameters: EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsEventNumberGetRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseSyncApiFp(this.configuration).apiEnterpriseSyncCalibrationPointsEventNumberGet(requestParameters.eventNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseSyncApi
     */
    public apiEnterpriseSyncCalibrationPointsPost(requestParameters: EnterpriseSyncApiApiEnterpriseSyncCalibrationPointsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return EnterpriseSyncApiFp(this.configuration).apiEnterpriseSyncCalibrationPointsPost(requestParameters.batchCreateCalibrationPointsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnterpriseSyncApiApiEnterpriseSyncEventDocumentsEventNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseSyncApi
     */
    public apiEnterpriseSyncEventDocumentsEventNumberGet(requestParameters: EnterpriseSyncApiApiEnterpriseSyncEventDocumentsEventNumberGetRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseSyncApiFp(this.configuration).apiEnterpriseSyncEventDocumentsEventNumberGet(requestParameters.eventNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnterpriseSyncApiApiEnterpriseSyncEventDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseSyncApi
     */
    public apiEnterpriseSyncEventDocumentsPost(requestParameters: EnterpriseSyncApiApiEnterpriseSyncEventDocumentsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return EnterpriseSyncApiFp(this.configuration).apiEnterpriseSyncEventDocumentsPost(requestParameters.batchCreateEventDocumentsCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

